export default __webpack_public_path__ + "asset/img/icon-hot~5acd5260.png";